module.exports = __webpack_public_path__ + "img/logo-kib.38449c26.svg";